module.exports = __webpack_public_path__ + "static/img/3.6636ead.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/3.png
// module id = kXkF
// module chunks = 0